/*jshint esversion:6 */
import DashboardPage from '../components/dashboard/dashboardPage';
import NewClaimPage from '../components/disputeMgmt/newClaim/newClaimPage';
import DisputesPage from '../components/disputeMgmt/disputes/disputesPage';
import BulkDisputesPage from '../components/disputeMgmt/bulkDisputes/bulkDisputesPage';
import ScriptsPage from '../components/admin/scripts/scriptsPage';
import ReasonCodesPage from '../components/admin/reasonCodes/reasonCodesPage';
import DisputeRegionsPage from '../components/admin/disputeRegions/disputeRegionsPage';
import TransactionGroupsPage from '../components/admin/transactionGroups/transactionGroupsPage';
import TransactionTypesPage from '../components/admin/transactionTypes/transactionTypesPage';
import TransactionTimelinesPage from '../components/admin/transactionTimelines/transactionTimelinesPage';
import DisputeTimelinesPage from '../components/admin/disputeTimelines/disputeTimelinesPage';
import MerchantDisputantsPage from '../components/admin/merchantDisputants/merchantDisputantsPage';
import SettlementRequestsPage from '../components/settlement/settlementRequests/settlementRequestsPage';
import SettlementPage from '../components/settlement/settlements/settlementPage';
import SettlementRulesPage from '../components/settlement/settlementRules/settlementRulesPage';
import DiscoverTransactionsPage from '../components/discover/newCase/TransactionsPage';
import DiscoverCasePage from '../components/discover/cases/DiscoverCasePage';
import CaseRequestPage from '../components/discover/caseRequests/CaseRequestPage';
import settingsConfigPage from '../components/admin/settingsConfig/settingsConfigPage'
import NotFound from '../components/notFound';

import Constants from './constants';
import SettlementReportsPage from '../components/settlement/settlementReports/settlementReportsPage';
import ReportsPage from '../components/reports/ReportsPage';
import URLS from './urls';
import bulkAccept from '../components/disputeMgmt/bulk_accept/BulkAccept';
import BulkUpdateStatus from '../components/disputeMgmt/bulk_update_status/BulkUpdateStatus';
import BulkDecline from '../components/disputeMgmt/bulk_dispute_decline/BulkDecline';

export default {
    DASHBOARD_ROUTE: {
        key: "dashboard",
        name: "Dashboard",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/dashboard`,
        pageComponent: DashboardPage
    },
    NEW_CLAIM_ROUTE: {
        key: "newDispute",
        name: "New Dispute",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/newDispute`,
        pageComponent: NewClaimPage
    },
    DISPUTES_ROUTE: {
        key: "disputes",
        name: "Disputes",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/disputes`,
        pageComponent: DisputesPage
    },
    BULK_DISPUTES_ROUTE: {
        key: "bulk_disputes",
        name: "Dispute Batches",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/bulkDisputes`,
        pageComponent: BulkDisputesPage
    },

    DISPUTE_REGIONS_ROUTE: {
        key: "disputeRegions",
        name: "Dispute Regions",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/disputeRegions`,
        pageComponent: DisputeRegionsPage
    },
    DISPUTE_TIMELINE_ROUTE: {
        key: "disputeTimelines",
        name: "Dispute Timelines",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/disputeTimelines`,
        pageComponent: DisputeTimelinesPage
    },
    DISPUTE_BULK_ACCEPT_ROUTE: {
        key: "disputeBulkAccept",
        name: "Bulk Updates",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/bulkUpdates`,
        pageComponent: bulkAccept
    },
    DISPUTE_UPDATE_STATUS_ROUTE: {
        key: "disputeBulkAcceptStatus",
        name: "Bulk Updates Status",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/bulkUpdatesStatus`,
        pageComponent: BulkUpdateStatus
    },
    DISPUTE_BULK_DECLINE_ROUTE: {
        key: "disputeBulkDecline",
        name: "Bulk Decline",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/bulkDisputeDecline`,
        pageComponent: BulkDecline
    },
    MERCHANT_DISPUTANT_ROUTE: {
        key: "merchantDisputant",
        name: "Merchant Disputants",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/merchantDisputant`,
        pageComponent: MerchantDisputantsPage
    },

    SETTINGS_CONFIG_ROUTE:{
        key: "settingsConfig",
        name: "Settings Configuration",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/settingsConfig`,
        pageComponent: settingsConfigPage
    },

    REASON_CODES_ROUTE: {
        key: "reasonCodesRoute",
        name: "Reason Codes",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/reasonCodes`,
        pageComponent: ReasonCodesPage
    },

    SCRIPTS_ROUTE: {
        key: "scripts",
        name: "Scripts",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/scripts`,
        pageComponent: ScriptsPage
    },
    TRANSACTION_GROUPS_ROUTE: {
        key: "transactionGroups",
        name: "Transaction Groups",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/transactionGroups`,
        pageComponent: TransactionGroupsPage
    },
    TRANSACTION_TYPES_ROUTE: {
        key: "transactionTypes",
        name: "Transaction Types",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/transactionTypes`,
        pageComponent: TransactionTypesPage
    },
    TRANSACTION_TIMELINE_ROUTE: {
        key: "transactionTimelines",
        name: "Transaction Timelines",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/transactionTimelines`,
        pageComponent: TransactionTimelinesPage
    },
    SETTLEMENT_REQUEST_ROUTE: {
        key: "settlementRequests",
        name: "Settlement Requests",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/settlement/settlementRequests`,
        pageComponent: SettlementRequestsPage
    },
    SETTLEMENT_RULES_ROUTE: {
        key: "settlementRules",
        name: "Settlement Rules",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/settlement/settlementRules`,
        pageComponent: SettlementRulesPage
    },
    SETTLEMENT_ROUTE: {
        key: "settlements",
        name: "Settlements",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/settlements/`,
        pageComponent: SettlementPage

    },
    SETTLEMENT_REPORTS_ROUTES: {
        key: "settlementsReports",
        name: "Settlement Reports",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/settlements/reports`,
        pageComponent: SettlementReportsPage

    },
    DISCOVER_TRANSACTIONS_ROUTE: {
        key: "discoverTransactions",
        name: "Discover Transactions",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/discover/transactions`,
        pageComponent: DiscoverTransactionsPage
    },
    DISCOVER_CASES_ROUTE: {
        key: "discoverCases",
        name: "Discover Cases",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/discover/cases`,
        pageComponent: DiscoverCasePage
    },
    DISCOVER_CASESREQUEST_ROUTE: {
        key: "caseRequests",
        name: "Case Requests",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/discover/case-requests`,
        pageComponent: CaseRequestPage
    },
    REPORTS_ROUTE: {
        key: "reports",
        name: "Reports",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/reports/`,
        pageComponent: ReportsPage
    },
    USER_GUIDE_ROUTE: {
        key: "userGuide",
        name: "User Guide",
        path: `${URLS.ARBITER_PUBLIC_FOLDER_URL}/user-guide.pdf`,
        subMenuType: "external"
    },
    FAQ_ROUTE: {
        key: "FAQs",
        name: "FAQs",
        path: `${URLS.ARBITER_PUBLIC_FOLDER_URL}/faq.pdf`,
        subMenuType: "external"
    },
    CUSTOMER_PORTAL_ROUTE: {
        key: "customer_portal",
        name: "Customer Portal",
        path: URLS.ISW_CUSTOMER_PORTAL_URL,
        subMenuType: "external"
    },
    NOTFOUND_ROUTE: {
        key: "pagenotfound",
        name: "PageNotFound",
        path: "*",
        exact: true,
        pageComponent: NotFound
    }
};


// WEBPACK FOOTER //
// ./src/configurations/routesConfig.js